import { html, css } from "lit";
import { customElement, property, query, queryAll } from "lit/decorators.js";
import { BaseSection } from "./sectionBase";

@customElement('rp-fsection-chart')
export class ChartSection extends BaseSection {

	static styles = [...BaseSection.styles, css`
		.row {
			margin: 0;
			display: flex;
			align-items: center;
			margin: 0 0 3px 3px;
		}

		.row:first-child {
			margin-top: 3px;
		}

		.row og-tree-dropdown {
			flex: 1;
			margin-right: 3px;
		}

		.row og-button {
			flex: 0;
		}
	`];

	render = () => html`
		xxx
	`;

}
